// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-card {
  margin-bottom: 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  overflow: hidden;
}
.status-title {
  margin-bottom: 18px !important;
  font-weight: 600 !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.status-content {
  padding: 8px 0;
}
.status-info {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.status-icon {
  font-size: 18px;
}
.status-icon.success {
  color: #52c41a;
}
.status-icon.error {
  color: #f5222d;
}
.status-icon.spinning {
  color: #1890ff;
}
.status-icon.waiting {
  color: #faad14;
}
.status-message {
  font-size: 14px;
  line-height: 1.5;
}
.duration-info {
  margin-bottom: 8px !important;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
}
.download-button {
  align-self: flex-start;
  margin-top: 8px;
}
/* 进度条相关样式 */
.process-status-card .progress-section {
  margin: 16px 0;
}
.process-status-card .progress-section .ant-progress {
  margin-bottom: 8px;
}
.process-status-card .progress-section .progress-info {
  width: 100%;
  /* 状态提示文字样式 */
}
.process-status-card .progress-section .progress-info .ant-typography.ant-typography-success {
  color: #52c41a;
  font-weight: 500;
}
.process-status-card .progress-section .progress-info .ant-typography.ant-typography-warning {
  color: #faad14;
  font-weight: 500;
}
.process-status-card .progress-section .progress-info .ant-typography.ant-typography-danger {
  color: #ff4d4f;
  font-weight: 500;
}
/* 任务统计信息 */
.task-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 8px;
}
.task-stats .stat-item {
  display: inline-flex;
  align-items: center;
}
/* 文件列表样式 */
.files-status-list {
  margin-top: 24px;
  border-top: 1px solid #f0f0f0;
  padding-top: 16px;
}
.files-status-list h5 {
  margin-bottom: 16px;
}
.file-item {
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}
.file-item.file-status-completed {
  background-color: rgba(82, 196, 26, 0.05);
}
.file-item.file-status-failed {
  background-color: rgba(245, 34, 45, 0.05);
}
.file-item.file-status-processing {
  background-color: rgba(24, 144, 255, 0.05);
}
.file-item-content {
  width: 100%;
}
.file-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.file-name {
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}
.file-error {
  color: #f5222d;
  font-size: 12px;
}
.file-duration {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}
.file-status-icon {
  font-size: 16px;
  margin-right: 8px;
}
.file-status-icon.success {
  color: #52c41a;
}
.file-status-icon.error {
  color: #f5222d;
}
.file-status-icon.spinning {
  color: #1890ff;
}
.file-status-icon.waiting {
  color: #faad14;
}
/* PDF页面列表样式 */
.pages-collapse {
  margin-top: 8px;
  width: 100%;
}
.pages-collapse .ant-collapse-header {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.pages-collapse .ant-collapse-content-box {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.page-item {
  padding: 6px 0 !important;
}
.page-item.page-status-failed .page-error {
  color: #f5222d;
  font-size: 12px;
  margin-top: 4px;
  margin-left: 22px;
}
`, "",{"version":3,"sources":["webpack://./src/renderer/components/ProcessStatus.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;AACF;AAEA;EACE,8BAAA;EACA,2BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAAF;AAGA;EACE,cAAA;AADF;AAIA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;AAKA;EACE,eAAA;AAHF;AAKE;EACE,cAAA;AAHJ;AAME;EACE,cAAA;AAJJ;AAOE;EACE,cAAA;AALJ;AAQE;EACE,cAAA;AANJ;AAUA;EACE,eAAA;EACA,gBAAA;AARF;AAWA;EACE,6BAAA;EACA,eAAA;EACA,0BAAA;AATF;AAYA;EACE,sBAAA;EACA,eAAA;AAVF;AACA,YAAY;AAaZ;EAEI,cAAA;AAZJ;AAUA;EAKM,kBAAA;AAZN;AAOA;EASM,WAAA;EAbJ,aAAa;AACf;AAgBQ;EACE,cAAA;EACA,gBAAA;AAdV;AAiBQ;EACE,cAAA;EACA,gBAAA;AAfV;AAkBQ;EACE,cAAA;EACA,gBAAA;AAhBV;AACA,WAAW;AAuBX;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;AArBF;AAiBA;EAOI,oBAAA;EACA,mBAAA;AArBJ;AACA,WAAW;AAyBX;EACE,gBAAA;EACA,6BAAA;EACA,iBAAA;AAvBF;AAoBA;EAMI,mBAAA;AAvBJ;AA2BA;EACE,eAAA;EACA,gCAAA;AAzBF;AA2BE;EACE,yCAAA;AAzBJ;AA4BE;EACE,yCAAA;AA1BJ;AA6BE;EACE,0CAAA;AA3BJ;AA+BA;EACE,WAAA;AA7BF;AAgCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA9BF;AAiCA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA/BF;AAkCA;EACE,cAAA;EACA,eAAA;AAhCF;AAmCA;EACE,eAAA;EACA,0BAAA;AAjCF;AAoCA;EACE,eAAA;EACA,iBAAA;AAlCF;AAoCE;EACE,cAAA;AAlCJ;AAqCE;EACE,cAAA;AAnCJ;AAsCE;EACE,cAAA;AApCJ;AAuCE;EACE,cAAA;AArCJ;AACA,cAAc;AAyCd;EACE,eAAA;EACA,WAAA;AAvCF;AAqCA;EAKI,2BAAA;EACA,8BAAA;AAvCJ;AAiCA;EAUI,yBAAA;EACA,4BAAA;AAxCJ;AA4CA;EACE,yBAAA;AA1CF;AA4CE;EAEI,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AA3CN","sourcesContent":[".status-card {\n  margin-bottom: 20px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.status-title {\n  margin-bottom: 18px !important;\n  font-weight: 600 !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.status-content {\n  padding: 8px 0;\n}\n\n.status-info {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.status-icon {\n  font-size: 18px;\n  \n  &.success {\n    color: #52c41a;\n  }\n  \n  &.error {\n    color: #f5222d;\n  }\n  \n  &.spinning {\n    color: #1890ff;\n  }\n  \n  &.waiting {\n    color: #faad14;\n  }\n}\n\n.status-message {\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.duration-info {\n  margin-bottom: 8px !important;\n  font-size: 13px;\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.download-button {\n  align-self: flex-start;\n  margin-top: 8px;\n}\n\n/* 进度条相关样式 */\n.process-status-card {\n  .progress-section {\n    margin: 16px 0;\n    \n    .ant-progress {\n      margin-bottom: 8px;\n    }\n    \n    .progress-info {\n      width: 100%;\n      \n      /* 状态提示文字样式 */\n      .ant-typography {\n        &.ant-typography-success {\n          color: #52c41a;\n          font-weight: 500;\n        }\n        \n        &.ant-typography-warning {\n          color: #faad14;\n          font-weight: 500;\n        }\n        \n        &.ant-typography-danger {\n          color: #ff4d4f;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n}\n\n/* 任务统计信息 */\n.task-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 8px;\n  \n  .stat-item {\n    display: inline-flex;\n    align-items: center;\n  }\n}\n\n/* 文件列表样式 */\n.files-status-list {\n  margin-top: 24px;\n  border-top: 1px solid #f0f0f0;\n  padding-top: 16px;\n  \n  h5 {\n    margin-bottom: 16px;\n  }\n}\n\n.file-item {\n  padding: 12px 0;\n  border-bottom: 1px solid #f0f0f0;\n  \n  &.file-status-completed {\n    background-color: rgba(82, 196, 26, 0.05);\n  }\n  \n  &.file-status-failed {\n    background-color: rgba(245, 34, 45, 0.05);\n  }\n  \n  &.file-status-processing {\n    background-color: rgba(24, 144, 255, 0.05);\n  }\n}\n\n.file-item-content {\n  width: 100%;\n}\n\n.file-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.file-name {\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.file-error {\n  color: #f5222d;\n  font-size: 12px;\n}\n\n.file-duration {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.45);\n}\n\n.file-status-icon {\n  font-size: 16px;\n  margin-right: 8px;\n  \n  &.success {\n    color: #52c41a;\n  }\n  \n  &.error {\n    color: #f5222d;\n  }\n  \n  &.spinning {\n    color: #1890ff;\n  }\n  \n  &.waiting {\n    color: #faad14;\n  }\n}\n\n/* PDF页面列表样式 */\n.pages-collapse {\n  margin-top: 8px;\n  width: 100%;\n  \n  .ant-collapse-header {\n    padding-top: 4px !important;\n    padding-bottom: 4px !important;\n  }\n  \n  .ant-collapse-content-box {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n}\n\n.page-item {\n  padding: 6px 0 !important;\n  \n  &.page-status-failed {\n    .page-error {\n      color: #f5222d;\n      font-size: 12px;\n      margin-top: 4px;\n      margin-left: 22px;\n    }\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
